/** Per-kind rules, mirroring OPINK `ConsentPurposeKindExtensions`. A new kind must declare both. */
const KIND_RULES = {
    Communication: { allowsSending: true, requiresExplicitConsent: false },
    Tracking: { allowsSending: false, requiresExplicitConsent: true },
};
/** A kind OPINK ships before this portal knows it: never a send target, shown only once granted. */
const UNKNOWN_KIND_RULES = { allowsSending: false, requiresExplicitConsent: true };
function rulesOf(kind) {
    return Object.prototype.hasOwnProperty.call(KIND_RULES, kind) ? KIND_RULES[kind] : UNKNOWN_KIND_RULES;
}
/** Whether a communication action may target this purpose. */
export function allowsSending(purpose) {
    return rulesOf(purpose.kind).allowsSending;
}
/** Whether only an explicit decision on this purpose is worth showing, and only while it is switched on. */
export function requiresExplicitConsent(kind) {
    return rulesOf(kind).requiresExplicitConsent;
}
/** Kind of a catalogue code; a code missing from the catalogue predates kinds, so it is a communication purpose. */
export function purposeKindOf(catalogue, code) {
    return catalogue.get(code)?.kind ?? "Communication";
}
